import { css } from '@emotion/css'

const styles = {
  wrapper: css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    userSelect: 'none',
  }),
}

export default styles

export const wrapperSize = size =>
  css({
    width: size,
    height: size,
  })

export const iconSize = size =>
  css({
    maxWidth: size,
    maxHeight: size,
  })
